import { map } from "rxjs";
import { Image } from "../../model";
import apiService from "../ApiService";

const getGamePassesImg = (uuid: string) => {
  console.log("uuid passes info", uuid);
  return apiService
    .get<{ images: Image[] }>({
      path: `public/game_passes/${uuid}/images`,
      edito: true,
    })
    .pipe(map((e) => e.images));
};
export { getGamePassesImg };
